import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent {
  @Input() modalWidth: string = '600px';
  @Input() modalTitle: string = '';
  @Output() closeModal: EventEmitter<void> = new EventEmitter();

  handleClose() {
    this.closeModal.emit();
  }
}
